import type { AxiosInstance, AxiosResponse } from 'axios';

import instantSurveyApi from './api';
import { createApiRequestConfig, transformApiResponseData } from '../utilities/api_case';
import { transformQuestion } from './utilities/helpers';
import type { Question } from './types';

const axios = instantSurveyApi as AxiosInstance;

interface TemplateQuestions {
  count: number;
  next: null | string;
  previous: null | string;
  results: Question[];
}

interface TemplateQuestionsResponse extends Omit<TemplateQuestions, 'results'> {
  results: Parameters<typeof transformQuestion>[0][];
}

/**
 * Read the standard red herring (attention check) template bank questions.
 */
export const readRedHerringQuestions = async ({
  limit,
  offset,
  questionType,
  signal,
}: {
  limit?: number;
  offset?: number;
  questionType?: string;
  signal?: AbortSignal;
} = {}): Promise<TemplateQuestions> => {
  return axios(
    createApiRequestConfig({
      method: 'get',
      params: { limit, offset, questionType },
      signal,
      url: '/instantsurvey/standard_red_herring_questions',
    })
  ).then(({ data }: AxiosResponse<TemplateQuestionsResponse>) => {
    const { results, ...pagination } = data;

    return {
      ...transformApiResponseData(pagination),
      results: results.map((question) => transformQuestion(question) as Question),
    } as TemplateQuestions;
  });
};
